/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getSuperstackingSettings} from '../api'

 export const useQueryGetSuperstackingSettings = createReactQueryHook('getSuperstackingSettings', getSuperstackingSettings)
